import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, isRef as _isRef } from "vue"

import MyDialog from "~/cabinet/vue/interface/dialog/MyDialog.vue";
import DateHelper from "~/ts/library/Date";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import {computed, ref} from "vue";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import getOperatorDisplayName from "~/operatorApplication/ts/service/operators/getOperatorDisplayName";
import {requiredRule} from "~/core-ui/ts/CoreUiHelpersMixin";
import {__} from "~/ts/library/Translate";
import MyDateTimePicker from "~/core-ui/vue/ui/MyDateTimePicker.vue";
import DateTimeInputControls from "~/operatorApplication/vue/misc/DateTimeInputControls.vue";


const __default__ = {
    name: "CreateNotificationDialog"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    userdata: {},
    site: {}
  }, {
    "visible": { type: Boolean },
    "visibleModifiers": {},
  }),
  emits: ["update:visible"],
  setup(__props: any) {

let props = __props;

let isVisible = _useModel<boolean>(__props, "visible");
function close() {
    isVisible.value = false;
}

let date = new Date();
date.setDate(date.getDate() + 1);
date.setHours(10);
date.setMinutes(0);

let model = ref<{
    text: string,
    dateTime: string,
    operatorIds?: string[]
}>({
    text: null,
    dateTime: (new DateHelper(date)).toMysqlFormat(),
    operatorIds: null
});

async function send() {
    let p: OperatorApplicationApi.OperatorCreateNotificationOpenApiModel = {
        username: props.userdata.username,
        text: model.value.text,
        dateTime: Math.ceil((new DateHelper(model.value.dateTime)).dateObject.getTime() / 1000),
        operatorIds: model.value.operatorIds
    }
    let result = await (new OperatorApiRequest({
        url: "/message/createNotification",
        p
    })).send();
    if (!result.showMessageOnError()) {
        close();
    }
}

let operators = computed(() => {


    let logins = OperatorAccountStore.sitesDictionary.value[props.userdata.siteId]?.operators ?? [];
    let result: OperatorApplicationApi.OperatorGetParamsOperatorOpenApiModel[] = [];
    for (let login of logins) {
        let operator = OperatorAccountStore.operatorsDictionary.value[login];
        if (operator) {
            result.push(operator);
        }
    }

    return result;
});


return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createBlock(MyDialog, {
    visible: _unref(isVisible),
    "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (_isRef(isVisible) ? (isVisible).value = $event : isVisible = $event)),
    title: _unref(__)('Создать напоминание'),
    form: {
            model: _unref(model),
            labelPosition: 'left',
            labelWidth: '150px'
        },
    "button-text": _unref(__)('Создать'),
    onApply: send
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        label: _unref(__)('Дата'),
        rules: _unref(requiredRule),
        prop: "dateTime"
      }, {
        default: _withCtx(() => [
          _createVNode(MyDateTimePicker, {
            modelValue: _unref(model).dateTime,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(model).dateTime) = $event)),
            format: "DD.MM.YYYY HH:mm"
          }, null, 8, ["modelValue"]),
          (__props.site)
            ? (_openBlock(), _createBlock(DateTimeInputControls, {
                key: 0,
                modelValue: _unref(model).dateTime,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(model).dateTime) = $event)),
                site: __props.site
              }, null, 8, ["modelValue", "site"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["label", "rules"]),
      (_unref(operators).length > 0)
        ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: _unref(__)('Получатель')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _unref(model).operatorIds,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(model).operatorIds) = $event)),
                multiple: "",
                clearable: "",
                placeholder: _unref(__)('Вы'),
                class: "w-100"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(operators), (operator) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: operator.id,
                      value: operator.id,
                      label: _unref(getOperatorDisplayName)(operator)
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_form_item, {
        label: _unref(__)('Текст'),
        rules: _unref(requiredRule),
        prop: "text"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            type: "textarea",
            modelValue: _unref(model).text,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(model).text) = $event)),
            autosize: {minRows: 5, maxRows: 10}
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["label", "rules"])
    ]),
    _: 1
  }, 8, ["visible", "title", "form", "button-text"]))
}
}

})